import {useUserAdminService} from '../../../controllers/DashboardServiceController'
import {NewPassword} from './NewPassword'

export default function NewDashUserPassword() {
    const userAdminService = useUserAdminService()
    return <NewPassword setPassword={userAdminService.resetDashUserPassword} heading={'New dashboard user password'}/>
}
